import { defineComponent } from "vue";

import { COMPONENT_NAME } from "./attributes";
import { RoutesName } from "@/shared/constants/enums";

import {
  DefaultToolbar,
  DefaultContent,
  DefaultNavbar,
  DefaultModal,
} from "@/components/layouts/default";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    DefaultToolbar,
    DefaultContent,
    DefaultNavbar,
    DefaultModal,
  },
  data() {
    return {
      isModal: false,
      userRepo: this.$projectServices.userRepo,
      userRepository: this.$projectServices.userRepository,
    };
  },
  computed: {
    needsKnowledgeTest(): boolean {
      return (
        this.userRepo.isVerified &&
        !this.userRepo.userInfo.user_info.user_agreement
      );
    },
  },
  watch: {
    needsKnowledgeTest: {
      immediate: true,
      handler(required) {
        if (required && this.$route.name !== RoutesName.settings) {
          this.$router.replace({
            name: RoutesName.settings,
            query: { tab: "market-test" },
          });
        }
      },
    },
  },
  methods: {
    async setUserAgreement(): Promise<void> {
      try {
        await this.userRepository.userAgreement({ user_agreement: true });
        this.isModal = false;
      } catch (error) {
        console.error("Failed to set user agreement:", error);
      }
    },
  },
});
